import { render, staticRenderFns } from "./VideoItem3.vue?vue&type=template&id=0c1f99ba"
import script from "./VideoItem3.vue?vue&type=script&lang=js"
export * from "./VideoItem3.vue?vue&type=script&lang=js"
import style0 from "./VideoItem3.vue?vue&type=style&index=0&id=0c1f99ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports